import { useEffect, useRef, useState } from "react";
import ReactCrop, { convertToPixelCrop } from "react-image-crop";
import setCanvasPreview from "./Setcanvas";
import "react-image-crop/dist/ReactCrop.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const MIN_DIMENSION = 150;

const ImageCropper = (props) => {
  const { closeModal, updateAvatar, selectedImage } = props;
  const imgRef = useRef(null);
  const previewCanvasRef = useRef(null);
  const [imgSrc, setImgSrc] = useState("");
  const [crop, setCrop] = useState();
  const [error, setError] = useState("");
  const [filepart, setfile] = useState();
  const[Filesent , setfilesent] = useState(false)

  useEffect(() => {
    onSelectFile(selectedImage);
    setfilesent(false);
  }, []);
  const onImageLoad = (e) => {
    const { width, height } = e.currentTarget;
    const cropWidthInPercent = (MIN_DIMENSION / width) * 100;

    const crop = {
      unit: "%",
      width: cropWidthInPercent,
      height: (MIN_DIMENSION / height) * 100,
    };

    setCrop(crop);
  };
  const getCroppedImg = (imageRef, crop, fileName) => {
    props.getCroppedImg(imageRef, crop, fileName);
  };

  

  const onSelectFile = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
  
    setfile(file);
  
    const reader = new FileReader();
    reader.addEventListener("load", () => {
      const imageElement = new Image();
      const imageUrl = reader.result?.toString() || "";
      imageElement.src = imageUrl;
  
      imageElement.addEventListener("load", (e) => {
        const { naturalWidth, naturalHeight } = e.currentTarget;
        if (naturalWidth < MIN_DIMENSION || naturalHeight < MIN_DIMENSION) {
          toast.error("Image must be at least 150 x 150 pixels.");
          setImgSrc("");
          updateAvatar(""); 
          return;
        }
        
        if (error) setError("");
        setImgSrc(imageUrl);
      });
    });
    reader.readAsDataURL(file);
  };
  
  



  return (
    <>
      <ToastContainer />
      <div>
        {imgSrc && (
          <div className="Cropper_Wrapper">
            <div className="Cropper_Inner_Wrapper">
              <ReactCrop
                crop={crop}
                onChange={(pixelCrop, percentCrop) => setCrop(percentCrop)}
                minWidth={MIN_DIMENSION}
              >
                <img
                  ref={imgRef}
                  src={imgSrc}
                  alt="Upload"
                  style={{ maxHeight: "70vh" }}
                  onLoad={onImageLoad}
                />
              </ReactCrop>
              <div className="CropperFooter">
                <button
                  className="text-black font-mono text-xs rounded-2xl border-3 bg-sky-500 hover:bg-sky-600"
                  onClick={() => {
                    updateAvatar("");
                    closeModal();
                  }}
                >
                  Cancel
                </button>
  
                <button
                 disabled={Filesent == true ?  true : false}
                  className={`text-black font-mono text-xs rounded-2xl border-3 bg-sky-500 hover:bg-sky-600 ${Filesent == true ? "FileSended":"notsend"}`}
                  style={{ background: "#234492", color: "white" }}
                  // onClick={async () => {
                  //   const pixelCrop = convertToPixelCrop(
                  //     crop,
                  //     imgRef.current.width,
                  //     imgRef.current.height
                  //   );
  
                  //   setCanvasPreview(
                  //     imgRef.current,
                  //     previewCanvasRef.current,
                  //     pixelCrop
                  //   );
  
                  //   const croppedFile = await getCroppedImg(
                  //     imgRef,
                  //     pixelCrop,
                  //     "croppedimg.jpg"
                  //   );
  
                  //   console.log(croppedFile, "croppedFile");
  
                  //   const dataUrl = previewCanvasRef.current.toDataURL();
                  //   // updateAvatar(dataUrl);
  
                  //   // closeModal();
                  // }}

                  onClick={() => {
                    const pixelCrop = convertToPixelCrop(
                      crop,
                      imgRef.current.width,
                      imgRef.current.height
                    );
                  
                    setCanvasPreview(
                      imgRef.current,
                      previewCanvasRef.current,
                      pixelCrop
                    );
                  
                 getCroppedImg(
                      imgRef,
                      pixelCrop,
                      "croppedimg.jpg"
                    );
                    setfilesent(true)
                  
                    const dataUrl = previewCanvasRef.current.toDataURL();
                    // updateAvatar(dataUrl);
                  
                    // closeModal();
                  }}
                  

                >
                  Save
                </button>
              </div>
            </div>
          </div>
        )}
  
        {crop && (
          <canvas
            ref={previewCanvasRef}
            className="mt-4"
            style={{
              display: "none",
              border: "1px solid black",
              objectFit: "contain",
              width: 150,
              height: 150,
            }}
          />
        )}
      </div>
    </>
  );
  
};

export default ImageCropper;
